import type { ReactNode } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import styles from "./Label.module.scss";

export type LabelProps = {
  id: string;
  label?: ReactNode;
  labelId?: string;
  labelCaption?: React.ReactNode;
  checkable?: boolean;
  required?: boolean;
  showRequiredAsterisk?: boolean;
  labelClassName?: string;
};

export const Label = ({
  label,
  labelId,
  checkable,
  labelCaption,
  required,
  id,
  showRequiredAsterisk = true,
  labelClassName,
}: LabelProps): JSX.Element | null => {
  const { __ } = useTranslations();
  if (!label) return null;

  const requiredSign = showRequiredAsterisk ? "*" : "";
  const requiredText = required ? requiredSign : __("form_fields.optional");
  const extendedLabelText = !checkable ? requiredText : "";

  return (
    <label id={labelId} className={classNames(styles.label, labelClassName)} htmlFor={id}>
      <div>
        {label} {extendedLabelText}
      </div>
      {labelCaption && <div className={styles.labelCaption}>{labelCaption}</div>}
    </label>
  );
};
